/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import DataProvider from "../../../DataProvider";
import DataWidget from "../../../components/DataWidget";
import ActionButtons from "../ActionButtons";

class TableBody extends React.Component {
    /**
     * @callback OnClickRecord
     * @param {Object} data
     */
    /**
     *
     */
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        /**
         * Sort specification
         */
        sort: PropTypes.arrayOf(PropTypes.string),
        firstRecord: PropTypes.number,
        recordCount: PropTypes.number,
        pageSize: PropTypes.number,
        /**
         * Actions
         */
        actions: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.node,
            action: PropTypes.string.isRequired
        })),
        /**
         * @type {OnActionCallback}
         */
        onAction: PropTypes.func,
        hideRecColumn: PropTypes.bool,
        location: PropTypes.object
    };

    static defaultProps = {
        firstRecord: 0,
        pageSize: 0,
        recordCount: 0,
        hideRecColumn: false
    };

    constructor(props) {
        super(props);
        this.state = {
            clickAction: this.getClickAction(props)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({clickAction: this.getClickAction(nextProps)});
    }

    /**
     * Checks if there exists click action inside action list
     * @param props
     * @return {boolean}
     */
    getClickAction(props) {
        if (!props) props = this.props;
        if (!props.actions || props.actions.length == 0) return null;
        for (let action of props.actions) {
            if (!action.label && !action.icon) return action;
        }
        return null;
    }

    onAction(action, data) {
        if (!this.props.onAction) return;
        action = _.clone(action);
        action.data = data;
        this.props.onAction(action);
    }

    renderRows() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;
        let rows = dataProvider.getRowCount();
        if (!rows) return null;
        let result = [];
        let firstRecordIdx = this.props.firstRecord;
        let schema = dataProvider.getRecordSchema();
        let fields = schema.getFieldList();
        let idFieldName = schema.getIdProperty();
        let recordCount = (this.props.recordCount ? this.props.recordCount : rows);
        let idDesc = false;
        if (this.props.sort && this.props.sort[0] === "-" + idFieldName) idDesc = true;
        for (let i = 0; i < rows; i++) {
            let childProvider = dataProvider.getProvider(i);
            result.push(this.renderRow(childProvider, (idDesc ? recordCount - (firstRecordIdx + i) : firstRecordIdx + i + 1), fields, childProvider.getValue(idFieldName)));
        }
        return result;
    }

    renderActions(dataProvider) {
        if (!this.props.actions ||
            this.props.actions.length === 0 ||
            (this.props.actions.length === 1 && this.state.clickAction != null)) return null;

        return (
            <td key="actions">
                <ActionButtons className="btn-group-xs" actions={this.props.actions} onAction={(action) => this.onAction(action, dataProvider.getData())} location={this.props.location}/>
            </td>
        );
    }

    /**
     *
     * @param {DataProvider} dataProvider
     * @param recordIdx
     * @param fields
     * @param id
     * @returns {XML}
     */
    renderRow(dataProvider, recordIdx, fields, id) {
        return (
            <tr key={recordIdx} onClick={this.state.clickAction ? (() => this.onAction(this.state.clickAction, dataProvider.getData())) : null}>
                {
                    this.props.hideRecColumn ? null :
                        <td key="id">{recordIdx}</td>
                }
                {
                    _.map(fields, function (field) {
                        return (<td key={field}><DataWidget dataProvider={dataProvider} field={field} /></td>);
                    })
                }
                {this.renderActions(dataProvider)}
            </tr>
        );
    }

    render() {
        return (
            <tbody>
                {this.renderRows()}
            </tbody>
        );
    }
}

export default TableBody;
